import { gql } from 'types/__generated__';

const SEND_LICENSE_ASSIGNMENT_EMAIL = gql(/* GraphQL */ `
  mutation sendLicenseAssignmentEmail($data: SendLicenseAssignmentEmailInput!) {
    sendLicenseAssignmentEmail(data: $data)
  }
`);

export default SEND_LICENSE_ASSIGNMENT_EMAIL;
